'use strict';

import React from 'react';
import { CorePipelineProgressSummary } from './CorePipelineProgressSummary';
import { DISCOVERY_PROGRESS_COPY } from './pipelineProgressCopy';

/**
 * @param {{
 *   model: import('./pipelineCoreProgressModel').CorePipelineProgressModel,
 *   facts?: import('./pipelineStatusTypes').PipelineStatusFact[],
 *   projectId?: string,
 * }} props
 */
export function DiscoveryPanelsPipelineProgressSummary({ model, facts, projectId, definition }) {
	return (
		<CorePipelineProgressSummary
			model={model}
			facts={facts}
			projectId={projectId}
			definition={definition}
			copy={DISCOVERY_PROGRESS_COPY}
			testIdPrefix="discovery"
			detailKind="discoveryPanels"
		/>
	);
}
